import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdBlock = ({ placement, className = '' }) => {
  const [ad, setAd] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const fetchAd = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/ads/active/${placement}`);
        if (!cancelled && res.data) {
          setAd(res.data);
        }
      } catch {
        // No ad available — silent fail
      }
    };
    fetchAd();
    return () => { cancelled = true; };
  }, [placement]);

  const handleClick = () => {
    if (!ad) return;
    // Track click
    axios.post(`${API_URL}/api/ads/${ad.id}/click`).catch(() => {});
  };

  if (!ad) return null;

  const isVideo = Boolean(ad.video_url);
  const aspectRatio = ad.format === 'video_portrait' ? '9/16' : ad.format === 'video_landscape' ? '16/9' : undefined;

  return (
    <div
      className={`ad-block text-center my-4 ${className}`}
      data-placement={placement}
      data-testid={`ad-block-${placement}`}
    >
      <span className="text-[10px] uppercase tracking-widest text-muted-foreground block mb-1">
        Publicit&eacute;
      </span>
      {isVideo ? (
        <a
          href={ad.link_url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleClick}
          className="inline-block"
        >
          <video
            src={ad.video_url}
            autoPlay
            muted
            loop
            playsInline
            className="mx-auto rounded max-w-full"
            style={aspectRatio ? { aspectRatio } : undefined}
          />
        </a>
      ) : ad.image_url ? (
        <a
          href={ad.link_url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleClick}
          className="inline-block"
        >
          <img
            src={ad.image_url}
            alt={ad.title}
            className="mx-auto rounded max-w-full"
          />
        </a>
      ) : (
        <a
          href={ad.link_url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleClick}
          className="inline-block text-sm text-[#D62828] underline"
        >
          {ad.title}
        </a>
      )}
    </div>
  );
};

export default AdBlock;
